/* Drops of Nature PDP behaviour — vanilla port of the Claude Design component logic */
(function () {
  function init(root) {
    if (!root || root.__donInit) return; root.__donInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* scroll reveal */
    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('anim');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      root.querySelectorAll('.rv, .rvx').forEach(function (el) { io.observe(el); });
      setTimeout(function () { root.querySelectorAll('.rv, .rvx').forEach(function (el) { el.classList.add('in'); }); }, 2500);
    }

    /* gallery */
    var track = root.querySelector('[data-gal]');
    var dots = root.querySelectorAll('.gal-dot'), thumbs = root.querySelectorAll('.gal-thumb');
    var slide = 0;
    function mark(i) {
      slide = i;
      if (track && track.children[i]) { var gw = track.closest('.gal'); if (gw) gw.classList.toggle('on-ig', track.children[i].classList.contains('gal-ig')); }
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      if (!track) return; var n = track.children.length; var idx = ((i % n) + n) % n;
      track.scrollTo({ left: track.children[idx].offsetLeft - track.children[0].offsetLeft, behavior: 'smooth' });
      mark(idx);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var gp = root.querySelector('.gal-prev'), gn = root.querySelector('.gal-next');
    if (gp) gp.addEventListener('click', function () { go(slide - 1); });
    if (gn) gn.addEventListener('click', function () { go(slide + 1); });
    function syncIndex(sc, items, n, cb) {
      if (!items || items.length < 2) return;
      var step = items[1].offsetLeft - items[0].offsetLeft; if (step <= 0) return;
      var i = Math.round(sc.scrollLeft / step);
      if (sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4) i = n - 1;
      cb(Math.max(0, Math.min(n - 1, i)));
    }
    if (track) track.addEventListener('scroll', function () { syncIndex(track, track.children, track.children.length, function (i) { if (i !== slide) mark(i); }); }, { passive: true });

    /* plans + add to cart */
    var form = root.querySelector('[data-pdp-form]');
    var radios = root.querySelectorAll('.plan-radio');
    function current() { var r = root.querySelector('.plan-radio:checked'); return r || radios[0]; }
    function syncPlan() {
      var r = current(); if (!r) return;
      radios.forEach(function (x) { x.closest('.plan').classList.toggle('is-sel', x === r); });
      root.querySelectorAll('[data-pdp-price]').forEach(function (el) { el.textContent = r.dataset.price; });
      root.querySelectorAll('[data-pdp-unit]').forEach(function (el) { el.textContent = r.dataset.unit; });
      root.querySelectorAll('[data-pdp-was]').forEach(function (el) { el.textContent = r.dataset.was || ''; el.hidden = !r.dataset.was; });
      root.querySelectorAll('[data-pdp-save]').forEach(function (el) { el.textContent = r.dataset.save ? 'Save ' + r.dataset.save : ''; el.hidden = !r.dataset.save; });
      var spIn = form && form.querySelector('[data-pdp-sp]'), qIn = form && form.querySelector('[data-pdp-qty]');
      if (spIn) { spIn.value = r.dataset.sp || ''; spIn.disabled = !r.dataset.sp; }
      if (qIn) qIn.value = r.dataset.qty || 1;
    }
    radios.forEach(function (r) { r.addEventListener('change', syncPlan); });
    var addT;
    function flash(label) {
      var labels = root.querySelectorAll('[data-atc-label], [data-pdp-sbar]');
      labels.forEach(function (l) { l.textContent = label; });
      clearTimeout(addT);
      addT = setTimeout(function () { labels.forEach(function (l) { l.textContent = 'Add to cart'; }); }, 1800);
    }
    function add() {
      if (!form) return;
      var r = current(); var msg = root.querySelector('[data-pdp-msg]');
      var item = { id: Number(form.querySelector('[name=id]').value), quantity: Number((r && r.dataset.qty) || 1) };
      if (r && r.dataset.sp) item.selling_plan = Number(r.dataset.sp);
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
        .then(function () {
          if (msg) msg.hidden = true;
          flash('Added to cart');
          return fetch(root_url + 'cart.js').then(function (x) { return x.json(); });
        })
        .then(function (cart) {
          var ev = new Event('shopify:cart:lines-update', { bubbles: true });
          ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } });
          try { document.dispatchEvent(ev); } catch (e) {}
          document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          /* Oct 26 2026: open the refreshed cart drawer so the shopper sees the item and stays on the page */
          try { document.dispatchEvent(new Event('cart:update', { bubbles: true })); } catch (e) {}
          if (window.donCartRefreshOpen) window.donCartRefreshOpen();
        })
        .catch(function (err) {
          if (msg) { msg.hidden = false; msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.'; }
        });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    var sb = root.querySelector('[data-pdp-sbar]');
    if (sb) sb.addEventListener('click', add);
    root.querySelectorAll('[data-pdp-mid]').forEach(function (b) { b.addEventListener('click', function () { var f = root.querySelector('[data-pdp-form]'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' }); add(); }); });
    syncPlan();
    /* Oct 28 2026: the browser can restore a different checked radio on back/forward; keep the button = the selected option */
    window.addEventListener('pageshow', syncPlan);

    /* UGC auto-scroll */
    var row = root.querySelector('[data-ugc]');
    if (row && !reduce) {
      var x = row.scrollLeft, held = false, seen = true, last = 0, frame = 0, setW = 0, ugcT;
      var setWidth = function () { var t = row.firstElementChild ? row.firstElementChild.children : null; return t && t.length > 6 ? t[6].offsetLeft - t[0].offsetLeft : 0; };
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0]) seen = en[0].isIntersecting; }).observe(row);
      var hold = function () { held = true; clearTimeout(ugcT); };
      var release = function (d) { clearTimeout(ugcT); ugcT = setTimeout(function () { x = row.scrollLeft; held = false; }, d || 1400); };
      row.addEventListener('pointerdown', hold); row.addEventListener('touchstart', hold, { passive: true });
      row.addEventListener('pointerup', function () { release(); }); row.addEventListener('touchend', function () { release(); });
      row.addEventListener('mouseenter', hold); row.addEventListener('mouseleave', function () { release(400); });
      row.addEventListener('wheel', function () { hold(); release(1800); }, { passive: true });
      row.addEventListener('scroll', function () { if (!held) return; var w = setWidth(); if (w > 0 && row.scrollLeft >= w) row.scrollLeft -= w; }, { passive: true });
      var tick = function (now) {
        var dt = last ? Math.min(48, now - last) : 16; last = now;
        if (!setW || frame % 90 === 0) setW = setWidth(); frame++;
        if (!held && seen && setW > 0) { x += dt * 0.032; if (x >= setW) x -= setW; row.scrollLeft = x; }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    /* reviews carousel */
    var rrow = root.querySelector('[data-rev]');
    if (rrow) {
      var rdots = root.querySelectorAll('.rev-dot'), btns = root.querySelectorAll('.rev-btn');
      var items = function () { return rrow.firstElementChild ? rrow.firstElementChild.children : null; };
      var revGo = function (dir) { var it = items(); var step = it && it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : rrow.clientWidth * 0.8; rrow.scrollBy({ left: dir * step, behavior: 'smooth' }); };
      if (btns[0]) btns[0].addEventListener('click', function () { revGo(-1); });
      if (btns[1]) btns[1].addEventListener('click', function () { revGo(1); });
      rrow.addEventListener('scroll', function () { var it = items(); syncIndex(rrow, it, it ? it.length : 0, function (i) { rdots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }); }, { passive: true });
    }


    /* ingredient carousel arrows */
    var irow = root.querySelector('[data-ing]');
    if (irow) {
      var istep = function () { var c = irow.querySelector('.ing-card'); return c ? c.getBoundingClientRect().width + 16 : 220; };
      var ip = root.querySelector('.ing-prev'), inx = root.querySelector('.ing-next');
      if (ip) ip.addEventListener('click', function () { irow.scrollBy({ left: -istep() * 2, behavior: 'smooth' }); });
      if (inx) inx.addEventListener('click', function () { irow.scrollBy({ left: istep() * 2, behavior: 'smooth' }); });
    }


    /* v6 stack story: goal chips light up the ingredients that support it */
    var sxRow = root.querySelector('#sx-ings');
    var chips = root.querySelectorAll('.sx-chip');
    if (sxRow && chips.length) {
      var sxCount = root.querySelector('[data-sx-count]'), sxText = root.querySelector('[data-sx-text]');
      var setGoal = function (g, scroll) {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.goal === g ? 'true' : 'false'); });
        sxRow.setAttribute('data-goal', g);
        var n = 0, cards = sxRow.querySelectorAll('.ing-card'), sxTot = sxRow.getAttribute('data-total') || '12', sxUnit = sxRow.getAttribute('data-unit') || 'ingredients', sxLast = sxRow.getAttribute('data-last') || 'bp';
        cards.forEach(function (c, i) {
          var on = (' ' + c.dataset.g + ' ').indexOf(' ' + g + ' ') > -1;
          c.classList.toggle('is-on', on); if (on) n += parseInt(c.getAttribute('data-n') || '1', 10);
          c.style.order = on ? (c.dataset.k === sxLast && g !== 'all' ? 50 : i) : 100 + i;
        });
        if (sxCount) sxCount.textContent = g === 'all' ? 'All ' + sxTot + ' ' + sxUnit : n + ' of ' + sxTot + ' ' + sxUnit;
        var t = root.querySelector('template[data-sum="' + g + '"]');
        if (sxText && t) sxText.innerHTML = t.innerHTML;
        if (scroll) sxRow.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
      };
      chips.forEach(function (c) { c.addEventListener('click', function () { setGoal(c.dataset.goal, true); }); });
      var pressed = root.querySelector('.sx-chip[aria-pressed="true"]');
      setGoal(pressed ? pressed.dataset.goal : 'all', false);
    }
    root.querySelectorAll('[data-sx-buy]').forEach(function (a) { a.addEventListener('click', function (e) { var f = root.querySelector('.plans') || root.querySelector('[data-pdp-form]'); if (!f) return; e.preventDefault(); f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }); });

    /* FAQ: one open at a time */
    var fitems = root.querySelectorAll('.faq-item');
    fitems.forEach(function (it) {
      var b = it.querySelector('.faq-btn'), a = it.querySelector('.faq-a');
      if (!b) return;
      b.addEventListener('click', function () {
        var open = !it.classList.contains('is-open');
        fitems.forEach(function (o) {
          var on = o === it && open; o.classList.toggle('is-open', on);
          var ob = o.querySelector('.faq-btn'), oa = o.querySelector('.faq-a');
          if (ob) ob.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (oa) oa.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      });
    });
  }
  function boot() { document.querySelectorAll('.pdp[data-don-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* v2: sticky buy bar appears only once the main Add to cart button has scrolled past */
(function(){document.querySelectorAll('[data-don-pdp]').forEach(function(root){var bar=root.querySelector('.sbar'),atc=root.querySelector('.atc');if(!bar)return;if(!atc){bar.classList.add('is-shown');return;}var t=0;function u(){t=0;bar.classList.toggle('is-shown',atc.getBoundingClientRect().bottom<0);}function q(){if(!t)t=requestAnimationFrame(u);}window.addEventListener('scroll',q,{passive:true});window.addEventListener('resize',q);u();});})();
